import React from 'react';
import { actionType, createAction } from './actions';
import iUser from '../interfaces/User';
import iSerial from '../interfaces/Serial';

export default function useUsersSerials() {
  const [state, dispatch] = React.useReducer(
    (state: any, action: actionType) => {
      switch (action.type) {
        case 'SET_USERS_SERIALS':
          return {
            ...state,
            users: action.payload.users,
            serials: action.payload.serials,
          };
        case 'SET_SERIAL':
          return {
            ...state,
            serials: [...state.serials, action.payload],
          };
        case 'SET_REPORT_DATE':
          return {
            ...state,
            reportDate: action.payload,
          };
        default:
          return state;
      }
    },
    {
      users: [],
      serials: [],
      reportDate: null,
      csvPins: [],
    }
  );

  const usersSerialsDispatch = React.useMemo(
    () => ({
      setReportDate: (date: Date | string) => {
        dispatch(createAction('SET_REPORT_DATE', date));
      },
      setSerial: (serial: iSerial) => {
        dispatch(createAction('SET_SERIAL', serial));
      },
      setUsersSerials: ({
        users,
        serials,
      }: {
        users: iUser[];
        serials: iSerial[];
      }) => {
        dispatch(createAction('SET_USERS_SERIALS', { users, serials }));
      },
    }),
    []
  );

  return {
    ...usersSerialsDispatch,
    ...state,
  };
}
